module.exports = __webpack_public_path__ + "img/knausgaard_Sangen_om_den_roede_rubin.3c6b13d0.jpg";